import React from 'react'
import ReactDOM from 'react-dom'
import Root from './routes/root/rootRoute'
import MaintenanceRootRoute from './routes/maintenance/maintenanceRootRoute'
import { unregister } from './registerServiceWorker'
import './style/main.scss'
import { AppContainer } from 'react-hot-loader'
import createReduxStore from './redux/store'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import LoadingSpinner from './containers/loadingSpinner/loadingSpinnerContainer'
import { throttle } from 'lodash'
import axios from './redux/axios'
document.onmousemove = throttle(
  () => store.dispatch({ type: 'MOUSE_RESET' }),
  2000
)
document.onkeypress = throttle(
  () => store.dispatch({ type: 'KEY_PRESS' }),
  2000
)
const { store, history } = createReduxStore()

if (
  process.env.NODE_ENV !== 'development' &&
  window.location.protocol !== 'https:'
) {
  window.location =
    'https://' +
    window.location.hostname +
    window.location.pathname +
    window.location.hash
}

(function () {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  const makeUid = (length) => {
    return Array(length).join(',')
      .split(',')
      .map(() => chars.charAt(Math.floor(Math.random() * chars.length)))
      .join('')
  }

  const setDocumentTitle = (pathname) => {
    const title = pathname === '/' ? null : `MapMyGrad | ${pathname.substring(1)}`

    if (title) {
      document.title = title
    }
  }

  const updateOperation = (pathname) => {
    // make this operation the child of the previous operation
    window.appInsights.context.operation.parentId = window.appInsights.context.operation.id
    // give this operation a new ID
    window.appInsights.context.operation.id = makeUid(5)
    // set the operation name to the pathname
    window.appInsights.context.operation.name = pathname
  }

  const trackPageView = (pathname) => {
    // send navigation information to App Insights
    // trackPageView(name ?: string, url ?: string, properties ?: { [string]: string }, measurements ?: { [string]: number }, duration ?: number)
    window.appInsights.trackPageView(document.title, `${window.location.origin}${pathname}`, {}, {}, 0)
  }

  history.listen((event) => {
    try {
      setDocumentTitle(event.pathname)
      updateOperation(event.pathname)
      trackPageView(event.pathname)
    } catch (err) {
      const log = console.error || console.log
      log('Telemetry trackPageView FAILED', err)
    }
  })
}())

const render = (Component, customMessage = null) => {
  ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        <div>
          <ConnectedRouter history={history}>
            <Component customMessage={customMessage} />
          </ConnectedRouter>
          <LoadingSpinner />
        </div>
      </Provider>
    </AppContainer>,
    document.getElementById('root')
  )
}

let isPathBlocked = false
// if (window.location.pathname === '/gradplanner') { isPathBlocked = true }
// if (window.location.pathname === '/email-validated') { isPathBlocked = true }
// if (window.location.pathname === '/maintenance') { isPathBlocked = true }

if (isPathBlocked) {
  axios.get('/site-restrictions')
    .then(res => {
      let isClientAllowed = res.data.is_client_allowed
      if (isClientAllowed) {
        // render(Root)
        render(MaintenanceRootRoute, res.data.maint_message)
      } else {
        render(MaintenanceRootRoute, res.data.maint_message)
      }
      try {
        unregister()
      } catch (e) {
        console.log('could not unregister')
      }
    }).catch(err => {
      console.log(`ERROR: index /site-restrictions axios call: ${err}`)
      render(MaintenanceRootRoute, 'Site is temporarily down for maintenance.')
    })
} else {
  render(Root)
}

export const getReduxStore = () => store



// WEBPACK FOOTER //
// ./src/index.js